<!-- FileSelectButton.vue -->
<script lang="ts" setup>
import { ref } from 'vue';

    const props = withDefaults(defineProps<{
        label?: string,
        // fileType?: string,
        accept?: string, // .txt, .hl7, etc...
        title?: string,
        disabled?: boolean
    }>(), {
        label: "Import File",
        // fileType: "text/csv",
    });

    const emits = defineEmits<
        (e: 'fileSelected', file: File) => void
    >();

    const fileSelectButton = ref<HTMLInputElement | null>(null);

    function handleFileSelection(event:Event) {
        emitFileSelection(event);
        
        // Reset the input value to allow re-selection of the same file
        if (fileSelectButton.value) {
            fileSelectButton.value.value = "";
        }
    }
    
    function emitFileSelection(event:Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files)
            return;

        const file = input.files[0];
        if (file) {
            emits('fileSelected', file);
        }
    }
</script>
<template>
    <label for="fileInput" class="btn btn-primary" @click="fileSelectButton?.click()">
        {{ props.label ?? "Select File"}}
        <input
            ref="fileSelectButton"
            type="file"
            :disabled="props.disabled"
            @change="handleFileSelection"
            class="d-none"
            :title="props.title"
            :accept="props.accept" />
    </label>    
</template>